import React, { Component } from 'react';
import { ArrowRight, Mail, Clock, ShieldCheck, CheckCircle } from 'lucide-react';
const EMAIL = 'info@uk-medicolegal-assessment.com';
const SUBJECT = encodeURIComponent('New Website Enquiry');
const BODY = encodeURIComponent(`Dear UK Medicolegal Assessment,

I would like to enquire about your medico-legal reporting services. Please find my details and case information below:

Full Name: 
Organisation / Law Firm: 
Case Type (e.g. Personal Injury, Clinical Negligence, Family Court): 
Brief Case Summary: 
Specialty Required (e.g. Psychiatry, Orthopaedics, ENT): 
Urgency / Preferred Timescale: 
Any Additional Information: 

I look forward to hearing from you.

Kind regards,
`);
const MAILTO_LINK = `mailto:${EMAIL}?subject=${SUBJECT}&body=${BODY}`;
export function CTASection() {
  return <section id="contact" className="py-10 bg-cta-500" aria-label="Request a medico-legal report" data-id="element-57">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8" data-id="element-58">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-59">
          {/* Left: copy & reassurance */}
          <div data-id="element-60">
            <h2 className="text-3xl md:text-4xl lg:text-[2.75rem] font-bold text-white tracking-tight leading-tight mb-6" data-id="element-61">
              Request a Medico-Legal Report Today
            </h2>
            <p className="text-lg text-blue-100/90 mb-10 leading-relaxed max-w-lg" data-id="element-62">
              Tell us about your case and we'll recommend the right expert,
              provide a fee quote, and get your instruction moving — all within
              hours.
            </p>

            <div className="space-y-5 mb-10" data-id="element-63">
              <div className="flex items-center gap-3.5" data-id="element-64">
                <div className="w-10 h-10 rounded-xl bg-cta-600 border border-cta-700/40 flex items-center justify-center flex-shrink-0" data-id="element-65">
                  <Clock className="h-5 w-5 text-teal-300" data-id="element-66" />
                </div>
                <div data-id="element-67">
                  <span className="text-white font-semibold" data-id="element-68">
                    Response within 24 hours
                  </span>
                  <span className="text-blue-200 text-sm block" data-id="element-69">
                    Mon–Fri 9am–5pm · Mark "Urgent" for priority
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3.5" data-id="element-70">
                <div className="w-10 h-10 rounded-xl bg-cta-600 border border-cta-700/40 flex items-center justify-center flex-shrink-0" data-id="element-71">
                  <ShieldCheck className="h-5 w-5 text-teal-300" data-id="element-72" />
                </div>
                <div data-id="element-73">
                  <span className="text-white font-semibold" data-id="element-74">
                    Strictly confidential
                  </span>
                  <span className="text-blue-200 text-sm block" data-id="element-75">
                    ISO 27001 certified. GDPR compliant.
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3.5" data-id="element-76">
                <div className="w-10 h-10 rounded-xl bg-cta-600 border border-cta-700/40 flex items-center justify-center flex-shrink-0" data-id="element-77">
                  <CheckCircle className="h-5 w-5 text-teal-300" data-id="element-78" />
                </div>
                <div data-id="element-79">
                  <span className="text-white font-semibold" data-id="element-80">
                    No obligation
                  </span>
                  <span className="text-blue-200 text-sm block" data-id="element-81">
                    Free initial consultation and fee quote.
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Right: email CTA card */}
          <div className="bg-white rounded-2xl p-8 md:p-10 shadow-xl border border-warm-100 text-center" data-id="element-82">
            <div className="w-16 h-16 bg-teal-50 rounded-2xl flex items-center justify-center mx-auto mb-6" data-id="element-83">
              <Mail className="h-8 w-8 text-teal-600" data-id="element-84" />
            </div>
            <h3 className="text-2xl font-bold text-ink-900 mb-3" data-id="element-85">
              Get in Touch
            </h3>
            <p className="text-ink-500 leading-relaxed mb-4 max-w-sm mx-auto" data-id="element-86">
              Click below to send us an enquiry. Your default email app will
              open with our address and a template pre-filled for you.
            </p>
            <p className="text-sm font-semibold text-ink-700 mb-8" data-id="element-87">{EMAIL}</p>

            <a href={MAILTO_LINK} className="btn-primary w-full text-center mb-6" data-id="element-88">
              <Mail className="mr-2 h-5 w-5" data-id="element-89" />
              Send Us an Email
              <ArrowRight className="ml-2 h-5 w-5" data-id="element-90" />
            </a>

            {/* Deadline Guarantee Badge */}
            <div className="flex justify-center mb-6" data-id="element-91">
              <div className="inline-flex items-center gap-2.5 bg-warm-50 border border-warm-200 rounded-full px-5 py-2.5" data-id="element-92">
                <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#1a2332] to-[#2D3748] border-2 border-slate-400 flex items-center justify-center flex-shrink-0" data-id="element-93">
                  <Clock className="h-3.5 w-3.5 text-slate-300" data-id="element-94" />
                </div>
                <span className="text-xs font-bold text-ink-700" data-id="element-95">
                  1–3 Week Delivery Guarantee
                </span>
              </div>
            </div>

            <a href="/contact" className="inline-flex items-center text-sm font-semibold text-teal-600 hover:text-teal-700 transition-colors" data-id="element-96">
              View full contact details
              <ArrowRight className="ml-1.5 h-4 w-4" data-id="element-97" />
            </a>

            <div className="mt-8 pt-6 border-t border-warm-200 flex flex-wrap justify-center gap-x-6 gap-y-2 text-xs text-ink-400" data-id="element-98">
              <span className="flex items-center" data-id="element-99">
                <ShieldCheck className="h-3.5 w-3.5 mr-1.5 text-sage-500" data-id="element-100" />
                ISO 27001 Certified
              </span>
              <span className="flex items-center" data-id="element-101">
                <CheckCircle className="h-3.5 w-3.5 mr-1.5 text-sage-500" data-id="element-102" />
                GDPR Compliant
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}